import React, { useEffect, useState } from "react";
import axios from "axios";
import closeIcon from "../../Assets/Icons/close.svg";
import envConfig from "../../config/config";

const ApiListTable = ({ onClose }) => {
    const [apiData, setApiData] = useState([]);
    const [loading, setLoading] = useState(true);

    useEffect(() => {
        const fetchApiData = async () => {
            try {
                const response = await axios.get(
                    `${envConfig.REACT_APP_APIREPO_READ}/apirepo/v0.1/uds/apis`
                );
                if (response.data.success) {
                    setApiData(response.data.data);
                } else {
                    console.error("Failed to fetch API data");
                }
            } catch (error) {
                console.error("Error fetching API data:", error);
            } finally {
                setLoading(false);
            }
        };

        fetchApiData();
    }, []);

    const getMethodStyle = (method) => {
        const base = "w-[80px] text-center py-1 px-2 rounded font-medium text-sm"; // consistent width + styling
        switch (method.toUpperCase()) {
            case "GET":
                return `${base} bg - green - 100 text - green - 800`;
            case "POST":
                return `${base} bg - blue - 100 text - blue - 800`;
            case "DELETE":
                return `${base} bg - red - 100 text - red - 800`;
            case "PUT":
                return `${base} bg - yellow - 100 text - yellow - 800`;
            case "PATCH":
                return `${base} bg - purple - 100 text - purple - 800`;
            default:
                return `${base} bg - gray - 100 text - gray - 800`;
        }
    };



    return (
        <div className="fixed inset-0 flex pt-5 justify-center bg-black bg-opacity-50 z-50">
            <div className="bg-white rounded shadow-custom text-black w-[90vw] h-[90vh] max-w-6xl border border-gray-600 relative z-20">
                {/* Header */}
                <div className="sticky top-0 bg-[#002746] text-white h-12 flex items-center justify-between px-4 shadow-custom z-10 mb-4">
                    <h1 className="font-semibold text-lg">Total Api's</h1>
                    <button
                        onClick={onClose}
                        aria-label="Close"
                        className="border-none hover:bg-slate-700 hover:rounded-full"
                    >
                        <img src={closeIcon} alt="close" className="w-8 h-8" />
                    </button>
                </div>

                {/* Table Section */}
                <div className="px-4 max-h-[73vh] min-h-[50vh] overflow-y-auto">
                    {loading ? (
                        <div className="flex flex-col items-center justify-center mt-20">
                            <div className="w-12 h-12 border-4 border-blue-500 border-t-transparent rounded-full animate-spin"></div>
                            <p className="mt-4 text-gray-700 font-medium">Loading projects...</p>
                        </div>
                    ) : (
                        <table className="bg-white w-full border max-w-[85vw] border-gray-200">
                            <thead className="text-white border-b border-gray-200">
                                <tr className="bg-[#002746] border-b sticky top-[-1px] border-gray-200">
                                    <th className="text-left p-2 w-[90px] font-bold">Sr No</th>
                                    <th className="text-left p-2 font-bold">API Name</th>
                                    <th className="text-left p-2 font-bold">Method</th>
                                    <th className="text-left p-2 font-bold">Category</th>
                                </tr>
                            </thead>
                            <tbody className="bg-white text-black">
                                {apiData.map((api, index) => (
                                    <tr key={index} className="border-b hover:bg-gray-100">
                                        <td className="p-2">{index + 1}</td>
                                        <td className="p-2">{api.apiName}</td>
                                        <td className="p-2">
                                            <span className={getMethodStyle(api.method)}>{api.method}</span>
                                        </td>
                                        <td className="p-2">{api.tag}</td>
                                    </tr>
                                ))}
                            </tbody>
                        </table>
                    )}
                </div>
            </div>
        </div>
    );
};

export default ApiListTable;
